import { render, staticRenderFns } from "./MainContent.vue?vue&type=template&id=ea8394e0&"
import script from "./MainContent.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MainContent.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea8394e0')) {
      api.createRecord('ea8394e0', component.options)
    } else {
      api.reload('ea8394e0', component.options)
    }
    module.hot.accept("./MainContent.vue?vue&type=template&id=ea8394e0&", function () {
      api.rerender('ea8394e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/ethical-commission/meetings/components/MainContent/MainContent.vue"
export default component.exports